"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("@trs/utils");
var _general = require("@trs/utils/lib/general");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var StyledCurrency = _styledComponents["default"].span.withConfig({
  displayName: "Currency__StyledCurrency",
  componentId: "sc-r9pjfk-0"
})(["span{font-weight:normal;}"]);
StyledCurrency.displayName = 'StyledCurrency';
// locale mappings can be found here https://github.com/mozilla/language-mapping-list/blob/master/language-mapping-list.js
/**
 * Helper to convert currency with locale
 * @param {string|number} value - can be provided as string or number, we'll asume string and do parsefloat
 * @param {string} currency - currency, provided as code GBP, RON, USD etc.
 * @param {string} [locale=undefined] - locale, if not provided it will use system/browser locale
 */
var currencyParser = function currencyParser(value, currency, locale, decimals, shouldParseFloat) {
  var amount = shouldParseFloat ? parseFloat(value, 10) : (0, _utils.floor)(value);
  if (!amount && amount !== 0) return amount;
  // toLocaleString is supported across all browsers except android webview - should be ok
  var defaultOptions = {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  };
  var options = _objectSpread({}, defaultOptions);
  if (currency) options.currency = currency;
  return currency === '%' ? (0, _general.formatNumber)(parseFloat(amount).toFixed(decimals), undefined) : (0, _general.formatNumber)(parseFloat(amount).toFixed(decimals), locale);
};
var Currency = function Currency(_ref) {
  var children = _ref.children,
    currency = _ref.currency,
    locale = _ref.locale,
    decimals = _ref.decimals,
    shouldParseFloat = _ref.shouldParseFloat,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(StyledCurrency, {
    className: "currency ".concat(className)
  }, /*#__PURE__*/_react["default"].createElement("strong", null, currencyParser(children, currency, locale, decimals, shouldParseFloat)), currency && /*#__PURE__*/_react["default"].createElement("span", null, " ", currency));
};
Currency.propTypes = {
  shouldParseFloat: _propTypes["default"].bool,
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  currency: _propTypes["default"].string,
  locale: _propTypes["default"].string,
  decimals: _propTypes["default"].number,
  className: _propTypes["default"].string
};
Currency.defaultProps = {
  shouldParseFloat: false,
  locale: undefined,
  children: '0',
  currency: 'GBP',
  decimals: 0,
  className: 'currency-wrapper'
};
Currency.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Currency",
  "props": {
    "shouldParseFloat": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "locale": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "children": {
      "defaultValue": {
        "value": "'0'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false
    },
    "currency": {
      "defaultValue": {
        "value": "'GBP'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "decimals": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "'currency-wrapper'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};
var _default = Currency;
exports["default"] = _default;